"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Analytics = void 0;
const store_1 = require("@completeanatomy/store");
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
const redux_watch_1 = __importDefault(require("redux-watch"));
require("reflect-metadata");
const typedi_1 = require("typedi");
const Pendo_1 = require("./providers/Pendo");
let Analytics = class Analytics {
    constructor(store, pendoProvider) {
        this.store = store;
        this.pendoProvider = pendoProvider;
        // Register all available analytics providers
        this.providers = [pendoProvider];
        const currentUserWatcher = (0, redux_watch_1.default)(this.store.getState, 'currentUser', lodash_isequal_1.default);
        this.store.subscribe(currentUserWatcher((newValue) => {
            /**
             * If newValue is not null and has an id, update the user session for Analytics
             */
            if (newValue && newValue.identifier) {
                this.updateUserSession(newValue);
            }
            else {
                /**
                 * If newValue is null or does not have an id, set an anonymous session
                 */
                this.setAnonymousSession();
            }
        }));
    }
    /**
     * Initialize Pendo with the provided API key
     */
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.providers.map(provider => provider.initialize()));
            const { currentUser, userLicenses } = this.store.getState();
            if (currentUser && currentUser.identifier) {
                const activeLicense = userLicenses === null || userLicenses === void 0 ? void 0 : userLicenses.find(license => license.isActive);
                if (activeLicense) {
                    // @ts-ignore -- hack to set productId on currentUser, create type for User with productId
                    currentUser.license = activeLicense.productId;
                }
                this.updateUserSession(currentUser);
            }
            else {
                this.setAnonymousSession();
            }
        });
    }
    log(eventName, properties = {}) {
        // Forward tracking to all registered providers
        this.providers.forEach(provider => {
            provider.log(eventName, properties);
        });
    }
    updateUserSession(user) {
        if (user) {
            this.providers.forEach(provider => {
                provider.updateUserSession(user);
            });
        }
    }
    /**
     * Initialize anonymous visitor session
     *
     * @returns void
     */
    setAnonymousSession() {
        this.providers.forEach(provider => {
            provider.setAnonymousSession();
        });
    }
    /**
     * Teardown all analytics providers
     *
     * @returns void
     */
    teardown() {
        this.providers.forEach(provider => {
            provider.teardown();
        });
    }
};
exports.Analytics = Analytics;
/**
 * Name of exported module property
 */
Analytics.exportName = 'analytics';
exports.Analytics = Analytics = __decorate([
    (0, typedi_1.Service)(),
    __param(0, (0, typedi_1.Inject)(store_1.StoreToken)),
    __metadata("design:paramtypes", [Object, Pendo_1.PendoProvider])
], Analytics);
